<template>
  <section id="login">
    <div style="margin-top:150px; margin-bottom:150px">
      <!-- Login Form -->

      <div class="container h-100 d-flex justify-content-center">
        <div class="login my-auto">
          <button type="button" aria-label="Close" class="close" @click="volver()">×</button>

          <div
            v-if="!arkidian && !adulto"
            class="container"
            style="text-align: center; padding:10px; margin-top:30px"
          >
            <h3 style="text-align:center; padding-bottom:15px">Registrarme en Arkidia</h3>
            <h5 style="text-align:center; padding-bottom:15px">¿Sos adulto a arkidian?</h5>

            <div class="row" style="justify-content:center">
              <div
                class="card categoria"
                @click="adulto=true"
                style="text-align: center; width:200px"
              >
                <img
                  src="public/images/site/gran-arkidian.svg"
                  width="100px"
                  alt="Arkidia"
                  style="align-self:center; padding:10px"
                />
                <h4 style="padding:10px">Adulto</h4>
              </div>
              <div
                class="card categoria"
                @click="arkidian=true"
                style="text-align: center; width:200px"
              >
                <img
                  src="public/images/site/mini-arkidian.svg"
                  width="100px"
                  alt="Arkidia"
                  style="align-self:center; padding:10px"
                />
                <h4 style="padding:10px">Arkidian</h4>
              </div>
            </div>
          </div>

          <div
            v-if="arkidian"
            class="container"
            style="text-align: center; padding:10px; margin-top:30px"
          >
            <h3 style="text-align:center; padding-bottom:15px">Registrarme en Arkidia</h3>
            <h5
              style="text-align:center; padding-bottom:15px"
            >Para usar Arkida necesitarás que un adulto te haga un usuario</h5>
            <img
              src="public/images/site/no-challenge.svg"
              width="400px"
              alt="Arkidia"
              style="align-self:center; padding:10px"
            />
            <div>
              <button type="button" class="btn btn-primary" @click="arkidian=false">Volver</button>
            </div>
          </div>

          <form v-if="adulto" style="padding:10px; margin:30px">
            <h3 style="text-align:center; padding-bottom:15px">Registrarme en Arkidia</h3>

            <div class="form-group">
              <label>Nombre</label>
              <input
                type="name"
                class="form-control"
                v-model="register.nombre"
                placeholder="Ingresá tu usuario"
              />
            </div>
            <div class="form-group">
              <label>Apellido</label>
              <input
                type="lastname"
                class="form-control"
                v-model="register.apellido"
                placeholder="Ingresá tu apellido"
              />
            </div>
            <div class="form-group">
              <label>Correo electrónico</label>
              <input
                type="email"
                class="form-control"
                v-model="register.mail"
                placeholder="Ingresá tu correo electrónico"
              />
            </div>

            <div class="form-group">
              <label>Contraseña</label>
              <input
                type="password"
                class="form-control"
                v-model="register.password"
                placeholder="Ingresá tu contraseña"
              />
            </div>

            <div class="form-group">
              <label>Repetir contraseña</label>
              <input
                type="password"
                class="form-control"
                v-model="register.passwordC"
                placeholder="Ingresá tu contraseña nuevamente"
              />
            </div>

            <div v-if="errorMessage" class="alert alert-danger" role="alert">{{errorMessage}}</div>

            <div style="text-align:center">
              <button
                type="button"
                class="btn boton-primario"
                @click="hacerRegistro(register)"
              >Registrarme</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "register",

  data() {
    return {
      errorMessage: "",
      adulto: false,
      arkidian: false,
      register: {
        nombre: "",
        apellido: "",
        mail: "",
        password: "",
        passwordC: ""
      }
    };
  },

  computed: {
    ...mapGetters(["pathAPI", "userLogged"])
  },

  methods: {
    hacerRegistro(register) {
      self = this;
      self.errorMessage = "";

      fetch(this.$store.state.pathAPI + "registracion.php", {
        method: "POST",
        body:
          "nombre=" +
          register.nombre +
          "&apellido=" +
          register.apellido +
          "&mail=" +
          register.mail +
          "&password=" +
          register.password +
          "&confirmacion=" +
          register.passwordC,
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      }).then(function(response) {
        if (response.ok) {
          var loginResponse = response.json();
          loginResponse.then(function(result) {
            if (result.resultado == "ERROR") {
              self.errorMessage = result.mensaje;
              sessionStorage.nombre = "";
              sessionStorage.usuario = "";
            } else {
              sessionStorage.nombre = register.nombre;
              sessionStorage.usuario = register.mail;
              self.$router.push({ path: "/Login" });
            }
          });
        } else {
          throw "Error en la llamada Ajax";
        }
      });
    },
    volver() {
      this.$router.push({ path: "/" });
    }
  },
  computed: {},
  components: {},

  mounted: function() {}
};
</script>

<style scoped>
#login {
  background: url("/public/images/site/background-login.svg");
  background-repeat: repeat-x;
  background-size: 1000px;
  display: table;
  width: 100%;
  background-position-y: top;
}
.login {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  background-color: #e9ecef;
  border-radius: 15px;
  -webkit-box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
  box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
}
.close {
  padding: 0px;
  font-size: 40px;
  font-weight: 300;
}
.label {
  margin-bottom: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/startPage/Register.vue